import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EMPTY, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ReferralService } from '@shared/services/referral.service';

import { referralGet, referralGetFailure, referralGetSuccess } from './referral.action';
import { ReferralState } from './referral.reducer';
import { getReferralById } from './referral.selectors';

@Injectable()
export class ReferralEffects {

  get$ = createEffect(() => this.actions$.pipe(
    ofType(referralGet),
    switchMap(({ referralId }) =>
      this.store.select(getReferralById, { id: referralId }).pipe(
        switchMap((referral) => {
          if (!referral) {
            return this.referralService.get({ id: referralId }).pipe(
              map((response) => referralGetSuccess({ referral: response })),
              catchError((error) => of(referralGetFailure({ error }))),
            );
          }
          return EMPTY;
        })
      )
    ),
  ));

  constructor(
    private actions$: Actions,
    private store: Store<ReferralState>,
    private referralService: ReferralService,
  ) {
  }
}
